export default __webpack_public_path__ + "static/media/joost_l.e283188a.jpg";